import {BaseCart, CartItem, CartItemQuery} from '@eastsideco/salvo-ts';

export default class Cart extends BaseCart

{
    constructor() {
        super();
    }

    public get itemCount(): number {
        return this.items.reduce((n, item) => {
            const packSize = item.properties &&
                Number(item.properties['_display_quantity']) ?
                Number(item.properties['_display_quantity']) : 1;
            return n + (item.quantity / packSize);
        }, 0);
    }

    public get itemsWithDisplayQuantities(): ItemWithDisplayQuantity[] {
        return this.items.map((item) => {
            const packSize = item.properties &&
                Number(item.properties['_display_quantity']) ?
                Number(item.properties['_display_quantity']) : 1;
            return {
                item,
                displayQuantity: item.quantity / packSize,
            };
        });
    }
}

interface ItemWithDisplayQuantity {
    item: CartItem;
    displayQuantity: number;
}

export const cart = new Cart();
